import { createSelector } from 'reselect'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'
import { isMobileScreenViewportSelect } from 'modules/viewport/selectors/index.js'

export const getPaddingHorizontalWorkoutSelect = createSelector(
  isSmallScreenViewportSelect,
  isMobileScreenViewportSelect,
  (isSmallScreen, isMobileScreen) => {
    let paddingHorizontal = 0
    if (isMobileScreen) {
      paddingHorizontal = '0.5rem'
    } else if (isSmallScreen) {
      paddingHorizontal = '1rem'
    } else {
      paddingHorizontal = '2rem'
    }

    return paddingHorizontal
  }
)
